"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeSessionManager = exports.SessionManager = void 0;
/**
 * Session Manager
 */
class SessionManager {
    /**
     * Initialize logout click handler
     *
     * Use this method to handle logout click events for elements
     * with the class `.js-action-logout-click`. Multiple elements
     * can trigger this event.
     */
    static initLogoutClick() {
        const logoutLinks = document.querySelectorAll('.js-action-logout-click');
        logoutLinks.forEach((logoutLink) => {
            logoutLink.addEventListener('click', SessionManager.handleLogoutClick);
        });
    }
    /**
     * Handle logout click
     */
    static handleLogoutClick() {
        sessionStorage.setItem("user_logged_out", "true");
    }
}
exports.SessionManager = SessionManager;
/**
* Initialize the session manager
*/
function initializeSessionManager() {
    document.addEventListener('DOMContentLoaded', () => {
        SessionManager.initLogoutClick();
    });
}
exports.initializeSessionManager = initializeSessionManager;
